import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { IWidgetManifest } from '../../types/widgetManifest';

export const MyHomeFormContainer: React.FC = () => {
  const { logger, config } = useApplicationContext();

  const manifest = config.get<IWidgetManifest>('myHomeFormManifest');

  if (!manifest) {
    if (process.env.IS_BROWSER_BUILD === 'true') {
      logger.error('Отсутствует манифест микрофронта формы добавления моего дома', {
        domain: 'microfrontends.frontend-valuation-form.manifest',
      });
    }

    return null;
  }

  return <Microfrontend {...manifest} />;
};
